export default "<app-page-content pageUrl=\"popi\"></app-page-content>\r\n"